import * as React from 'react'
import styled from 'styled-components'
import { media } from '../../../utils'
import SignatureCanvas from 'react-signature-canvas'
import { RedBtn, Btn } from 'src/components/atoms/input/buttons'

interface Props {
  grabSignature: (s) => void
  canvasHeight?: number
  canvasWidth?: number
  clever?: boolean
}

let colorStyles = {
  'border': '#a7c9cd',
  'borderError': '#974353',
  'bg': '#d5e4e6',
  'buttonBg': '#974353',
  'buttonDisabled': '#C6A3A9'
}

export default class Signature extends React.Component<Props> {
  signature

  constructor(props) {
    super(props)
  }

  componentWillUnMount() {
    if (this.signature) this.signature.off()
  }

  confirmSignature = () => {
    const { grabSignature } = this.props
    if (this.signature.isEmpty()) {
      grabSignature(null)
    } else {
      grabSignature(this.signature.getTrimmedCanvas().toDataURL('image/png'))
    }
  }

  clear = () => {
    this.signature.clear()
  }

 

  render() {
    const { canvasHeight, canvasWidth, clever } = this.props
    if(clever){
      colorStyles = {
        'border': '#FBB07F',
        'borderError': '#974154',
        'bg': '#FDD7BF',
        'buttonBg': '#040a31',
        'buttonDisabled': '#040a3199'
      }
    }
    return (
      <Container canvasHeight={canvasHeight} canvasWidth={canvasWidth}>
        <SignatureCanvas
          ref={(ref) => (this.signature = ref)}
          penColor='#4A4A4A'
          canvasProps={{ className: 'sig_canvas' }}
        />
        <ButtonContainer>
          <CustomRedBtn onClick={this.confirmSignature}>
            <i className='fas fa-check' />
          </CustomRedBtn>
          <CustomClearBtn onClick={this.clear}>
            <i className='fas fa-eraser' />
          </CustomClearBtn>
        </ButtonContainer>
      </Container>
    )
  }
}

const CustomRedBtn = styled(RedBtn)`
  background: ${(props) => (colorStyles.buttonBg)};
`
const CustomClearBtn = styled(Btn)`
  background: ${(props) => (colorStyles.buttonDisabled)};
`

const Container = styled.div`
  .sig_canvas {
    display: block;
    width: ${(props) => props.canvasWidth || '100%'};
    height: ${(props) => props.canvasHeight || '100%'};
    min-height: 300px;
    border: 5px solid #a7c9cd;
    border-color: ${(props) => (colorStyles.border)};
  }
`


const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 15px 0;
  & > * {
    width: 60px;
    height: 60px;
    min-width: unset;
    box-shadow: none;
    margin: 0;
    margin-left: 15px;
  }
  ${media.tablet`
    justify-content: space-evenly;
    & > * {
      margin: 0;
    }
  `}
`



// WEBPACK FOOTER //
// ./src/components/molecules/warrant/SignatureCanvas.tsx